import React from 'react';
export function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
}
export function createForkRef(...refs) {
    if (!refs.length) {
        return null;
    }
    return (refValue) => {
        refs.forEach((r) => {
            setRef(r, refValue);
        });
    };
}
export function withForwardedRef(Component) {
    if (!Component) {
        return null;
    }
    return React.forwardRef((props, ref) => {
        return React.createElement(Component, Object.assign({}, props, { forwardedRef: ref }));
    });
}
//# sourceMappingURL=reactHelpers.js.map